import { render } from "./AdicionarContatoRapidoModal.vue?vue&type=template&id=126c619b&scoped=true"
import script from "./AdicionarContatoRapidoModal.vue?vue&type=script&lang=js"
export * from "./AdicionarContatoRapidoModal.vue?vue&type=script&lang=js"

import "./AdicionarContatoRapidoModal.vue?vue&type=style&index=0&id=126c619b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126c619b"]])

export default __exports__